import { render, staticRenderFns } from "./528U.vue?vue&type=template&id=109ee662&"
import script from "./528U.vue?vue&type=script&lang=js&"
export * from "./528U.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('109ee662')) {
      api.createRecord('109ee662', component.options)
    } else {
      api.reload('109ee662', component.options)
    }
    module.hot.accept("./528U.vue?vue&type=template&id=109ee662&", function () {
      api.rerender('109ee662', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/msg/528U.vue"
export default component.exports